// DatabaseCampaigns.js
import React from 'react';
import { Box, Grid, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';        // re-uses .steps-list + .thumb rules

export default function DatabaseCampaigns() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Database&nbsp;Campaigns
      </Typography>

 
        {/* ——— Left column: steps & info ——— */}
      <Typography paragraph>
            Connect up to <strong>five</strong> live databases to PostSheet.
            Supported engines:
            <em> MySQL, PostgreSQL, Oracle, SQLite&nbsp;and&nbsp;SQL&nbsp;Server.</em>
          </Typography>

   
            <List className="steps-vertical" sx={{marginLeft:"2rem"}}>
                                      <ListItem sx={{marginLeft:"1rem"}}>
              <Typography variant='h4'>
                From <strong>Home</strong>, click&nbsp;<em>Add&nbsp;Database</em>.
              </Typography>
            </ListItem>

               <ListItem sx={{marginLeft:"1rem"}}>
               <Typography variant='h4'>
                Pick the database&nbsp;type from the drop-down.
              </Typography>
            </ListItem>

        <ListItem sx={{marginLeft:"1rem"}}>
               <Typography variant='h4'>
                Fill in <em>Alias</em>, <em>Host</em>, <em>Port</em>,{' '}
                <em>Database&nbsp;Name</em>, <em>User</em> and&nbsp;
                <em>Password</em>.
              </Typography>
            </ListItem>

      <ListItem sx={{marginLeft:"1rem"}}>
               <Typography variant='h4'>
                Press&nbsp;<strong>Save&nbsp;&amp;&nbsp;Test</strong>. PostSheet
                runs a quick connection check and stores the credentials.
              </Typography>
            </ListItem>
          </List>
           <img
            src="../../static/docs/AddDatabase.jpg"
            alt="Add database connection form"
            className="step-img"
          />
<Box sx={{backgroundColor: "#f8de73", borderRadius: '4px', p: 1, mt: 2}}>
          <Typography paragraph sx={{ mt: 2 }}>
            All credentials are<strong>&nbsp;AES-encrypted at rest</strong> and
            can be revoked at any time from the Database tab.
          </Typography>
          </Box>
    

        {/* ——— Right column: screenshot ——— */}
      
    </Box>
  );
}
